import axios, { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { UserRoles } from '../../api/queries.ts';

type LoginForm = {
  email: string;
  password: string;
};

type LoginResponse = {
  message: string;
  userAssignedRoles: Array<UserRoles>;
};

export const login = ({
  email,
  password,
}: LoginForm): Promise<AxiosResponse<LoginResponse>> => {
  return axios.post('api/auth/login', { email, password });
};

export const useLoginMutation = () => {
  return useMutation<LoginResponse, Error, LoginForm>({
    mutationFn: async ({ email, password }) => (await login({ email, password })).data,
  });
};
